<template>
	<div class="px-3 pt-0 pb-3 uplimit-progress-page">
		<!-- 页面顶部日历选择器 -->
		<div class="date-selector" style="text-align: left; padding: 0px 0; border-bottom: 1px solid var(--border-color); margin-bottom: 0px; display: flex; align-items: center; justify-content: left;">
			<b-form-datepicker 
				size="sm" 
				@context="onDateChange" 
				v-model="selectedEndDate" 
				class="mb-1" 
				today-button 
				close-button 
				locale="zh" 
				:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"
				style="width: 150px; flex-shrink: 0;">
			</b-form-datepicker>
			
			<div style="margin-left: 15px; display: flex; align-items: center;">
				<span style="font-size: 14px; color: var(--text-muted); white-space: nowrap; margin-right: 5px;">显示最近</span>
				<b-form-select 
					v-model="dayn" 
					:options="dayOptions" 
					size="sm" 
					@change="get_trade_days"
					style="width: 60px;">
				</b-form-select>
				<span style="font-size: 14px; color: var(--text-muted); white-space: nowrap; margin-left: 5px;">个交易日</span>
			</div>
			
			<div v-if="row4Mode === 'popular'" style="margin-left: 15px; display: flex; align-items: center;">
				<span style="font-size: 14px; color: var(--text-muted); white-space: nowrap; margin-right: 5px;">人气Top</span>
				<b-form-select 
					v-model="popularLimit" 
					:options="popularLimitOptions" 
					size="sm" 
					style="width: 65px;">
				</b-form-select>
			</div>
			
			<div v-if="row4Mode === 'pct'" style="margin-left: 15px; display: flex; align-items: center;">
				<span style="font-size: 14px; color: var(--text-muted); white-space: nowrap; margin-right: 5px;">统计周期</span>
				<b-form-select 
					v-model="cumDays" 
					:options="cumDaysOptions" 
					size="sm" 
					style="width: 75px;">
				</b-form-select>
				<span style="font-size: 14px; color: var(--text-muted); white-space: nowrap; margin-left: 5px;">交易日</span>
			</div>
		</div>

		
	<div class="row no-gutters flex-nowrap">
			<!-- 第一行：题材列表 -->
			
			<!-- 左侧 sidebar -->
			<div class="col-auto px-1" style="width: 50px;">
				<div class="text-center mb-2 pt-1 border-bottom pb-1">
					<span style="font-size: 0.9rem; font-weight: bold; color: #ced4da; line-height: 22px;">排名</span>
				</div>
				<!-- 排名列表 -->
				<div class="ranking-items-container">
					<div v-for="i in 12" :key="'rank-'+i" class="mb-1 text-center">
						<div class="ranking-item d-flex align-items-center justify-content-center" :class="{'ranking-highlight-1': i===1, 'ranking-highlight-2': i===2 || i===3}">
							{{ i }}
						</div>
					</div>
				</div>
			</div>
			
			<!-- 右侧数据列 -->
			<div class="col overflow-hidden">
				<div class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollTopic" @scroll="handleScroll('scrollTopic')">
					<template v-if="days && days.length">
						<RatePlate class="px-2 col" style="min-width: var(--col-width, 140px);" v-for="day in days" :date1="day" :key="'plate-'+day" :plate_type=17
							:selectedPlateCode="selectedPlateCode" @plate-selected="handlePlateSelected" :showUplimitStep=0 :show_score="1"
							@show_sidebar="show_sidebar" @first-plate-loaded="handleFirstPlateLoaded" @show-plate-kline="handleShowPlateKline"
                            @data-loaded="handleRatePlateDataLoaded">
						</RatePlate>
					</template>
				</div>
			</div>
		</div>

		<!-- 第二行：强度图表 -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<!-- 左侧 sidebar -->
			<div class="col-auto px-1 border-right" style="width: 50px; display: flex; align-items: center; justify-content: center;">
				<div style="font-size: 12px; font-weight: bold; color: #ced4da; writing-mode: vertical-lr; letter-spacing: 4px;">板块强度</div>
			</div>
			<!-- 图表 -->
			<div class="col px-0 overflow-hidden" ref="scrollIntensity" @scroll="handleScroll('scrollIntensity')" style="overflow-x: auto;">
                <div :style="{ width: 'calc(var(--col-width, 140px) * ' + days.length + ')', minWidth: '100%' }">
                    <PlateIntensityChart :days="days" :trendData="trendData" />
                </div>
			</div>
		</div>

		<!-- 第三行：成交额图表 -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<!-- 左侧 sidebar -->
			<div class="col-auto px-1 border-right" style="width: 50px; display: flex; align-items: center; justify-content: center;">
				<div style="font-size: 12px; font-weight: bold; color: #ced4da; writing-mode: vertical-lr; letter-spacing: 4px;">成交额</div>
			</div>
			<!-- 图表 -->
			<div class="col px-0 overflow-hidden" ref="scrollVolume" @scroll="handleScroll('scrollVolume')" style="overflow-x: auto;">
                <div :style="{ width: 'calc(var(--col-width, 140px) * ' + days.length + ')', minWidth: '100%' }">
                    <PlateVolumeChart :days="days" :trendData="trendData" />
                </div>
			</div>
		</div>

		<!-- 二级板块筛选 -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode && subPlates.length > 0">
			<!-- 左侧 sidebar -->
			<div class="col-auto px-1 border-right d-flex align-items-center justify-content-center" style="width: 50px;">
				<div style="font-size: 12px; font-weight: bold; color: #ced4da; white-space: nowrap;">二级</div>
			</div>
			<!-- 右侧标签 -->
			<div class="col pl-2 d-flex align-items-center flex-wrap sub-plates-filter-bar">
				<span 
					class="filter-pill-tag mr-2 mb-1" 
					:class="{'active': !selectedSubPlateCode}" 
					@click="selectedSubPlateCode = ''"
				>全部</span>
				<span 
					v-for="sub in subPlates" 
					:key="sub.code"
					class="filter-pill-tag mr-2 mb-1" 
					:class="{'active': selectedSubPlateCode === sub.code}" 
					@click="selectedSubPlateCode = sub.code"
				>
					{{ sub.name }}
					<span v-if="latestDateStr && subPlateStats[latestDateStr] && subPlateStats[latestDateStr][sub.code]" style="font-size: 0.85em; opacity: 0.9; margin-left: 4px;">
                        (<span :style="{ color: getRateColor(subPlateStats[latestDateStr][sub.code].quote_rate) }">{{ subPlateStats[latestDateStr][sub.code].quote_rate }}%</span>
                        | <span :style="{ color: getUpColor(subPlateStats[latestDateStr][sub.code].limit_up_count) }">{{ subPlateStats[latestDateStr][sub.code].limit_up_count }}</span>/<span :style="{ color: getDownColor(subPlateStats[latestDateStr][sub.code].limit_down_count) }">{{ subPlateStats[latestDateStr][sub.code].limit_down_count }}</span>)
                    </span>
				</span>
			</div>
		</div>

		<!-- 第三行：内容切换 (个股/梯队/人气/涨幅/K线) -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<div class="col-auto px-1 border-right" style="width: 50px;">
				<div class="pt-1 text-center d-flex flex-column align-items-center">
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'stock'}"
						@click="clickTab('stock')"
						title="成分个股"
					>个股</div>
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'step'}"
						@click="clickTab('step')"
						title="梯队详情"
					>梯队</div>
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'popular'}"
						@click="clickTab('popular')"
						title="人气表格"
					>人气</div>
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'pct'}"
						@click="clickTab('pct')"
						title="累计涨幅"
					>涨幅</div>
					<div 
						class="mode-switch-item" 
						:class="{'active': row4Mode === 'kline'}"
						@click="clickTab('kline')"
						title="板块K线"
					>K线</div>
				</div>
			</div>
			<div class="col pl-0 overflow-hidden">
				<!-- 个股模式 -->
				<div v-if="row4Mode === 'stock'" class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollStock" @scroll="handleScroll('scrollStock')">
					<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="day in days" :key="'stock-'+day">
						<StockListOnPlate 
							:plate_code="selectedSubPlateCode ? selectedSubPlateCode : selectedPlateCode" 
							:plate_type="selectedSubPlateCode ? 18 : 17"
							:date1="day" 
							:highlight-stock-name="activeHighlightStock"
							@stock-clicked="handleStockClicked"
							@show_sidebar="show_sidebar"
						></StockListOnPlate>
					</div>
				</div>
				<!-- 梯队模式 -->
				<div v-else-if="row4Mode === 'step'" class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollLadder" @scroll="handleScroll('scrollLadder')">
					<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="day in days" :key="'step-'+day">
						<UplimitStepOnPlate :plate_code="selectedPlateCode" :date1="day" :filter-stock-codes="subPlateStocksMap[day] ? subPlateStocksMap[day][selectedSubPlateCode] : null" @show_sidebar="show_sidebar" @show-plate-kline="handleShowPlateKline"></UplimitStepOnPlate>
					</div>
				</div>
				<!-- 人气模式 -->
				<div v-else-if="row4Mode === 'popular'" class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollPopular" @scroll="handleScroll('scrollPopular')">
					<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="(day, idx) in days" :key="'popular-'+day">
						<PopularListOnPlate 
							:plate_code="selectedSubPlateCode ? selectedSubPlateCode : selectedPlateCode" 
							:plate_type="selectedSubPlateCode ? 18 : 17"
							:date1="day" 
							:is-latest="idx === 0"
							:highlight-stock-name="activeHighlightStock"
							:limit="popularLimit"
							@latest-first-stock="handleLatestFirstStock"
							@stock-clicked="handleStockClicked"
							@show_sidebar="show_sidebar"
						></PopularListOnPlate>
					</div>
				</div>
				<!-- 涨幅模式 -->
				<div v-else-if="row4Mode === 'pct'" class="position-relative" style="min-height: 200px;">
					<div v-if="requireRotationSubscription" class="locked-overlay d-flex flex-column align-items-center justify-content-center p-4 text-center">
						<div class="lock-circle mb-3">
							<b-icon icon="lock-fill" font-scale="1.8"></b-icon>
						</div>
						<h5 class="font-weight-bold mb-2">开通涨幅区间 VIP</h5>
						<p class="text-muted small mb-3">您今日的免费试用次数（3次）已用完，请订阅该功能模块以获得无限次访问。</p>
						<b-button size="sm" variant="warning" class="rounded-pill px-4 font-weight-bold" @click="$router.push({ path: '/subscription', query: { module: 'pct_interval_vip' }})">
							立即订阅
						</b-button>
					</div>

					<div :class="{'blur-content': requireRotationSubscription}">
						<div class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollPct" @scroll="handleScroll('scrollPct')">
							<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="day in days" :key="'pct-'+day">
								<PlateStockPctOnPlate
									:plate_code="selectedPlateCode"
									:date1="day"
									:daysBack="cumDays"
									:stocksData="pctDataMap[day]"
									:loadingProp="loadingPct"
									is-batch
									:highlight-stock-name="selectedStockNamePct"
									:filter-stock-codes="subPlateStocksMap[day] ? subPlateStocksMap[day][selectedSubPlateCode] : null"
									@stock-clicked="handleStockClickedPct"
									@show_sidebar="show_sidebar"
								></PlateStockPctOnPlate>
							</div>
						</div>
					</div>
				</div>
				<!-- K线模式 -->
				<div v-else-if="row4Mode === 'kline'">
					<StockKlineDay :symbol_code="currentKlinePlateCode" :title="currentKlinePlateName" :subText="currentKlinePlateCode" :highlightDate="selectedDate" :chart_heigh="'450px'" :zoom_start="40" :kline_url="currentKlineUrl"></StockKlineDay>
					
					<!-- 板块爆发原因 -->
					<div class="plate-reasons" v-if="selectedPlateCode">
						<div class="plate-reasons-header">
							<h5>板块爆发原因</h5>
							<span v-if="loadingReasons" class="loading">加载中...</span>
						</div>
						<div v-if="!loadingReasons && reasonAuthRequired" class="empty">
							需要登录后查看板块爆发原因 
							<b-button size="sm" variant="outline-primary" class="login-btn" @click="goLogin">去登录</b-button>
						</div>
						<div v-else-if="!loadingReasons && plateReasons.length === 0" class="empty">暂无数据</div>
						<div v-else class="reasons-list">
							<div class="reason-item" v-for="(r, idx) in plateReasons" :key="r.newid || idx">
								<div class="reason-title">
									<span class="date">{{ r.date }}</span>
									<span class="boom" v-if="r.isboom">爆发</span>
									<a href="#" class="title" @click.prevent="toggleReason(r)">{{ r.title }}</a>
								</div>
								<div class="reason-meta">
									<span v-if="r.ztnum != null">涨停数：{{ r.ztnum }}</span>
									<span v-if="r.index != null">指数：{{ r.index }}</span>
									<span v-if="r.qd != null">强度：{{ r.qd }}</span>
								</div>
								<div class="reason-text" v-if="r.boomreason">{{ r.boomreason }}</div>
								<div class="reason-lz" v-if="r.lzinfo">龙头：{{ r.lzinfo }}</div>
								<div class="reason-content" v-if="reasonExpanded[r.newid]">
									<div v-if="reasonLoadingContent[r.newid]" class="loading">内容加载中...</div>
									<div v-else>
										<div class="reason-detail-meta" v-if="reasonContentMap[r.newid] && reasonContentMap[r.newid].createTime">
											时间：{{ formatReasonTimestamp(reasonContentMap[r.newid].createTime) }}
										</div>
										<div v-html="reasonContentMap[r.newid] && reasonContentMap[r.newid].content"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 板块K线图（组件化） -->
		<PlateKlineModal
			:visible="showPlateKline"
			:plateCode="selectedPlateCode"
			:plateName="selectedPlateName"
			:selectedDate="selectedDate"
			@close="closePlateKline"
		/>

		<StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>
		<LoginModal ref="loginModal" @success="onLoginSuccess" />
		<div class="mt-2 text-muted small">感谢<router-link to="/contact" class="text-accent font-weight-bold">捐赠</router-link>服务器费用</div>

	</div>

</template>

<script>
	import moment from 'moment';
	import RatePlate from 'components/plate/RatePlate.vue'
	import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'
	import PlateKlineModal from 'components/plate/PlateKlineModal.vue'
    import PlateIntensityChart from 'components/plate/PlateIntensityChart.vue'
    import UplimitStepOnPlate from 'components/uplimit/UplimitStepOnPlate.vue'
    import PlateVolumeChart from 'components/plate/PlateVolumeChart.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'
	import PopularListOnPlate from 'components/uplimit/PopularListOnPlate.vue'
	import PlateStockPctOnPlate from 'components/uplimit/PlateStockPctOnPlate.vue'
	import StockListOnPlate from 'components/stock/StockListOnPlate.vue'
	import LoginModal from '@/components/login/LoginModal'

	import {
		request_zzquant
	} from "network/request.js"

	export default {
		data() {
			return {
				selectedPlateCode: "",
				selectedPlateName: "",
				showPlateKline: false,
				firstPlateSet: false, // 添加标志位，确保只设置一次
				days: [],
				latestFirstStock: null,
				selectedStockName: null,
				subPlates: [],
				selectedSubPlateCode: "",
				subPlateStocksMap: {},
				subPlateStats: {},
				popularLimit: 30,
				popularLimitOptions: [20, 30, 50, 100],
				dayn: 10,
				dayOptions: [5, 6, 8, 10, 12, 15],
				symbol_name: "",
				symbol_code: "",
				selectedDate: null,
				date_mark: "",
				selectedEndDate: (() => {
					const now = moment();
					const currentTime = now.format('HH:mm');					
					if (currentTime < '09:31'){
						return now.format('YYYY-MM-DD');
					} else {
						return now.add(1, 'days').format('YYYY-MM-DD');
					}
				})(),
                plateDataMap: {}, // Store stocks data per date: { 'YYYY-MM-DD': [stocks...] }
                trendData: [], // Trend data for charts - MUST be defined here for reactivity
				plateReasons: [],
				loadingReasons: false,
				reasonAuthRequired: false,
				reasonContentMap: {},
				reasonLoadingContent: {},
				reasonExpanded: {},
				row4Mode: 'popular', // 'stock', 'step', 'popular', 'kline', 'pct'
				cumDays: 10,
				cumDaysOptions: [5, 10, 20],
				pctDataMap: {},
				loadingPct: false,
				requireRotationSubscription: false,
				selectedStockNamePct: null
			};
		},
        computed: {
            activeHighlightStock() {
                return this.selectedStockName || this.latestFirstStock;
            },
            latestDateStr() {
                return this.days && this.days.length > 0 ? this.days[0] : null;
            },
            currentKlinePlateCode() {
                return this.selectedSubPlateCode ? this.selectedSubPlateCode : this.selectedPlateCode;
            },
            currentKlinePlateName() {
                if (this.selectedSubPlateCode && this.subPlates) {
                    const sub = this.subPlates.find(s => s.code === this.selectedSubPlateCode);
                    return sub ? sub.name : this.selectedPlateName;
                }
                return this.selectedPlateName;
            },
            currentKlineUrl() {
                if (this.selectedSubPlateCode) {
                    return `v3/market/kline/sub-plate/${this.selectedSubPlateCode}`;
                }
                return '';
            },
            chartDataValues() {
                if (!this.days || this.days.length === 0 || !this.selectedPlateCode) return [];
                
                return this.days.map(day => {
                   const stocks = this.plateDataMap[day];
                   if (!stocks) return null;
                   
                   const found = stocks.find(s => s.plate_code === this.selectedPlateCode);
                   // Assuming 'score' is the intensity value. Or 'rate'? 'score' matches '9922' magnitude likely.
                   // Previous code passed 'data.score' to c_num if show_score=1.
                   return found ? found.score : null; // Use null for missing points or connect? null breaks line. 0?
                   // ECharts handles null by breaking line or ignoring. Let's try finding the data.
                }); 
            }
        },
		created() {
			// Priority: localStorage > query param > default
            const savedDayn = localStorage.getItem('uplimit_progress_dayn');
            const queryDayn = this.$route.query.dayn;
            
            if (savedDayn) {
                this.dayn = parseInt(savedDayn);
            } else if (queryDayn) {
                this.dayn = parseInt(queryDayn);
            }
            
            const savedPopularLimit = localStorage.getItem('uplimit_progress_popularLimit');
            if (savedPopularLimit) {
                this.popularLimit = parseInt(savedPopularLimit);
            }
            const savedCumDays = localStorage.getItem('uplimit_progress_cumDays');
            if (savedCumDays) {
                this.cumDays = parseInt(savedCumDays);
            }
		},
        watch: {
            selectedPlateCode(val) {
                this.latestFirstStock = null;
                this.selectedStockName = null;
                this.selectedStockNamePct = null;
                this.selectedSubPlateCode = "";
                this.subPlates = [];
                this.subPlateStocksMap = {};
                this.subPlateStats = {};
                if (val) {
                    this.fetchTrend();
                    this.loadPlateReasons();
                    this.fetchSubPlatesAndStocks();
                    if (this.row4Mode === 'pct') {
                        this.fetchPctBatch();
                    }
                    if (!this.selectedPlateName) {
                        const firstDay = this.days[0];
                        const stocks = this.plateDataMap[firstDay] || [];
                        const found = stocks.find(s => s.plate_code === val);
                        if (found) {
                            this.selectedPlateName = found.plate_name;
                        }
                    }
                }
            },
            days: {
                handler(val) {
                    this.latestFirstStock = null;
                    this.selectedStockName = null;
                    this.selectedStockNamePct = null;
                    if (val && val.length > 0 && this.selectedPlateCode) {
                        this.fetchTrend();
                        this.fetchSubPlatesAndStocks();
                        if (this.row4Mode === 'pct') {
                            this.fetchPctBatch();
                        }
                    }
                }
            },
            dayn(val) {
                // Persist to localStorage
                localStorage.setItem('uplimit_progress_dayn', val);
            },
            popularLimit(val) {
                localStorage.setItem('uplimit_progress_popularLimit', val);
            },
            cumDays(val) {
                localStorage.setItem('uplimit_progress_cumDays', val);
                if (this.row4Mode === 'pct') {
                    this.fetchPctBatch();
                }
            },
            row4Mode(val) {
                if (val === 'pct') {
                    this.fetchPctBatch();
                }
            }
        },
		mounted() {
			this.get_trade_days();
		},
		components: {
			RatePlate,
			StockInfoSidebar,
			PlateKlineModal,
            PlateIntensityChart,
            UplimitStepOnPlate,
            PlateVolumeChart,
			StockKlineDay,
			PopularListOnPlate,
			PlateStockPctOnPlate,
			StockListOnPlate,
			LoginModal
		},
		methods: {
            getRateColor(rate) {
                if (!rate) return 'inherit';
                if (rate > 0) {
                    if (rate >= 5) return '#ff2a2a';
                    if (rate >= 2) return '#ff5555';
                    return '#ff8888';
                } else if (rate < 0) {
                    if (rate <= -5) return '#00e600';
                    if (rate <= -2) return '#33ff33';
                    return '#88ff88';
                }
                return 'inherit';
            },
            getUpColor(count) {
                return count > 0 ? '#ff5555' : 'inherit';
            },
            getDownColor(count) {
                return count > 0 ? '#33ff33' : 'inherit';
            },
            fetchTrend() {
                if (!this.selectedPlateCode || !this.days || this.days.length === 0) {
                    this.trendData = [];
                    return;
                }
                
                const sortedDays = [...this.days].sort();
                const start = sortedDays[0];
                const end = sortedDays[sortedDays.length - 1];

                request_zzquant({
                    url: '/market/plates/17/trend',
                    params: {
                        plate_code: this.selectedPlateCode,
                        day_start: start,
                        day_end: end
                    }
                }).then(res => {
                    this.trendData = res.data.data || [];
                }).catch(err => {
                    console.error("Fetch trend error", err);
                    this.trendData = [];
                });
            },
            fetchPctBatch() {
                if (!this.selectedPlateCode || !this.days || this.days.length === 0) {
                    this.pctDataMap = {};
                    return;
                }
                this.loadingPct = true;
                this.requireRotationSubscription = false;
                const datesStr = this.days.join(",");
                request_zzquant({
                    url: `/v3/market/plates/17/${this.selectedPlateCode}/stocks/pct/batch`,
                    params: {
                        dates: datesStr,
                        days: this.cumDays
                    },
                    noRedirect: true
                }).then(res => {
                    const resData = res.data || {};
                    const innerData = resData.data || {};
                    this.pctDataMap = innerData;
                }).catch(err => {
                    const status = err.status || (err.response && err.response.status);
                    if (status === 401) {
                        if (this.$refs.loginModal) {
                            this.$refs.loginModal.show();
                        }
                    } else if (status === 403) {
                        this.requireRotationSubscription = true;
                        this.pctDataMap = {};
                    } else {
                        console.error("Fetch pct batch error:", err);
                        this.pctDataMap = {};
                    }
                }).finally(() => {
                    this.loadingPct = false;
                });
            },
            fetchSubPlatesAndStocks() {
                if (!this.selectedPlateCode || !this.days || this.days.length === 0) {
                    this.subPlates = [];
                    this.subPlateStocksMap = {};
                    this.subPlateStats = {};
                    return;
                }
                const datesStr = this.days.join(",");
                request_zzquant({
                    url: `/v3/market/plates/17/${this.selectedPlateCode}/sub-plates-stocks`,
                    params: {
                        dates: datesStr
                    }
                }).then(res => {
                    const resData = res.data || {};
                    const innerData = resData.data || {};
                    this.subPlates = innerData.sub_plates || [];
                    this.subPlateStocksMap = innerData.stocks || {};
                    this.subPlateStats = innerData.stats || {};
                }).catch(err => {
                    console.error("Fetch sub-plates and stocks error:", err);
                    this.subPlates = [];
                    this.subPlateStocksMap = {};
                    this.subPlateStats = {};
                });
            },
            clickTab(mode) {
                if (mode === 'pct') {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        if (this.$refs.loginModal) {
                            this.$refs.loginModal.show();
                        }
                        return;
                    }
                }
                this.row4Mode = mode;
            },
            onLoginSuccess() {
                this.row4Mode = 'pct';
                this.fetchPctBatch();
            },
            handleRatePlateDataLoaded(date, stocks) {
                this.$set(this.plateDataMap, date, stocks);
                // Backup: If no plate selected and this is the first day, select the first plate
                if (!this.selectedPlateCode && this.days && this.days.length > 0 && date === this.days[0] && stocks.length > 0) {
                    this.selectedPlateCode = stocks[0].plate_code;
                    this.selectedPlateName = stocks[0].plate_name;
                }
            },
			// 日期选择变化处理
			onDateChange() {
				// 重置选中状态
				this.selectedPlateCode = "";
				this.selectedPlateName = "";
				this.firstPlateSet = false;
				this.latestFirstStock = null;
				this.selectedStockName = null;
				this.selectedStockNamePct = null;
                // Keep cache to avoid blank state on reuse
                // this.plateDataMap = {}; 
				
				// 触发数据刷新
				this.get_trade_days();
			},
			
			handlePlateSelected(plateCode, plateName) {
				this.selectedPlateCode = plateCode;
				if (plateName) {
					this.selectedPlateName = plateName;
				} else {
					const firstDay = this.days[0];
					const stocks = this.plateDataMap[firstDay] || [];
					const found = stocks.find(s => s.plate_code === plateCode);
					if (found) {
						this.selectedPlateName = found.plate_name;
					}
				}
			},
			handleFirstPlateLoaded(plateCode, date) {
				// 只在第一次加载时设置默认选中的plate_code
				if (!this.firstPlateSet && this.days && this.days.length > 0 && date === this.days[0]) {
					this.selectedPlateCode = plateCode;
					const stocks = this.plateDataMap[date] || [];
					const found = stocks.find(s => s.plate_code === plateCode);
					if (found) {
						this.selectedPlateName = found.plate_name;
					}
					this.firstPlateSet = true;
				}
			},
			handleShowKline(stock_code, stock_name) {
				this.symbol_code = stock_code
				this.symbol_name = stock_name
			},
			handleDateSelected(date) {
				this.selectedDate = date
			},
			handleLatestFirstStock(stockName) {
				this.latestFirstStock = stockName;
			},
			handleStockClicked(stockName) {
				if (this.selectedStockName === stockName) {
					this.selectedStockName = null;
				} else {
					this.selectedStockName = stockName;
				}
			},
			handleStockClickedPct(stockName) {
				if (this.selectedStockNamePct === stockName) {
					this.selectedStockNamePct = null;
				} else {
					this.selectedStockNamePct = stockName;
				}
			},
        show_sidebar(stock_info) {
            this.symbol_code = stock_info['stock_code'];
            this.symbol_name = stock_info['stock_name'];
            this.date_mark = stock_info['date1'];
        },
			get_trade_days() {
				// 使用选中的日期作为结束日期
				const today = this.selectedEndDate;
				request_zzquant({
						url: '/v3/market/trade/days?day_end=' + today + '&days=' + this.dayn
					})
					.then(res1 => {
						this.days = res1['data']['data'].slice().reverse();
						this.selectedDate = this.days[1];
                        
                        // If data for the first day is already cached (component reuse), select it manually
                        const firstDay = this.days[0];
                        if (this.plateDataMap[firstDay] && this.plateDataMap[firstDay].length > 0) {
                            // If selectedPlateCode is empty or invalid, set it
                            if (!this.selectedPlateCode) {
                                this.selectedPlateCode = this.plateDataMap[firstDay][0].plate_code;
                            }
                            this.firstPlateSet = true;
                        } else {
                            // If not cached, reset flag so child emit can set it
                            this.firstPlateSet = false;
                        }

                        // Force trend fetch if plate is selected
                        if (this.selectedPlateCode) {
                            this.$nextTick(() => {
                                this.fetchTrend();
                            });
                        }
					})
					.catch(err => {
						console.log(err);
					});
			},
			
			// 处理板块K线图显示
			handleShowPlateKline(plateInfo) {
				this.selectedPlateCode = plateInfo.code;
				this.selectedPlateName = plateInfo.name;
				this.showPlateKline = true;
			},
			
			// 关闭板块K线图
			closePlateKline() {
				this.showPlateKline = false;
			},
			
			// 同步水平滚动
			handleScroll(active) {
				const refs = ['scrollTopic', 'scrollIntensity', 'scrollVolume', 'scrollLadder', 'scrollPopular', 'scrollPct', 'scrollStock'];
				const activeRef = this.$refs[active];
				if (!activeRef) return;
				
				const scrollLeft = activeRef.scrollLeft;
				refs.forEach(r => {
					if (r !== active && this.$refs[r]) {
						this.$refs[r].scrollLeft = scrollLeft;
					}
				});
			},
			handleShowSidebarFromTable(stock_code, stock_name) {
				this.show_sidebar({
					stock_code: stock_code,
					stock_name: stock_name,
					date1: this.selectedDate
				});
			},
			loadPlateReasons() {
				if (!this.selectedPlateCode) return;
				this.loadingReasons = true;
				this.reasonAuthRequired = false;
				try {
					const tk = localStorage.getItem('token');
					if (!tk) this.reasonAuthRequired = true;
				} catch (e) { /* ignore */ }
				request_zzquant({
					url: `/v3/market/plate/popular/reason?plate_code=${this.selectedPlateCode}`,
					noRedirect: true
				})
					.then(res => {
						const data = res && res.data && res.data.data ? res.data.data : [];
						this.plateReasons = Array.isArray(data) ? data : [];
						this.reasonContentMap = {};
						this.reasonLoadingContent = {};
						this.reasonExpanded = {};
					})
					.catch(err => {
						console.log(err);
						const msg = (err && err.message) ? String(err.message) : '';
						const hints = ['无权限','未登录','验证失败','Unauthorized','需要登录','未授权'];
						const status401 = !!(err && err.status === 401);
						const unauthorized = !!(err && err.__unauthorized);
						const byMsg = hints.some(h => msg.indexOf(h) !== -1);
						this.reasonAuthRequired = !!(status401 || unauthorized || byMsg);
						this.plateReasons = [];
					})
					.finally(() => {
						this.loadingReasons = false;
					});
			},
			toggleReason(r) {
				const id = r.newid || r.msg_id;
				if (!id) return;
				if (this.reasonExpanded[id]) {
					this.$set(this.reasonExpanded, id, false);
					return;
				}
				if (this.reasonContentMap[id]) {
					this.$set(this.reasonExpanded, id, true);
					return;
				}
				this.$set(this.reasonLoadingContent, id, true);
				request_zzquant({
					url: `/v3/market/plate/popular/reason/content?msgid=${id}`,
					noRedirect: true
				})
					.then(res => {
						const d = res && res.data && res.data.data ? res.data.data : null;
						const title = d && (d.Title || d.title) ? (d.Title || d.title) : '';
						const contentHtml = d && (d.Content || d.content) ? (d.Content || d.content) : '';
						const createTime = d && (d.CreateTime || d.createTime || d.create_time) ? (d.CreateTime || d.createTime || d.create_time) : null;
						this.$set(this.reasonContentMap, id, { title, content: contentHtml, createTime });
						this.$set(this.reasonExpanded, id, true);
					})
					.catch(err => {
						console.log(err);
						this.$set(this.reasonContentMap, id, { title: '', content: '<div style="color:#d23">内容加载失败</div>', createTime: null });
						this.$set(this.reasonExpanded, id, true);
					})
					.finally(() => {
						this.$set(this.reasonLoadingContent, id, false);
					});
			},
			formatReasonTimestamp(ts) {
				if (!ts) return '';
				const num = typeof ts === 'number' ? ts : parseInt(ts, 10);
				if (!num) return '';
				const d = new Date(num * 1000);
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				const hh = String(d.getHours()).padStart(2, '0');
				const mm = String(d.getMinutes()).padStart(2, '0');
				return `${y}-${m}-${day} ${hh}:${mm}`;
			},
			goLogin() {
				try {
					const current = this.$route && this.$route.fullPath ? this.$route.fullPath : '/';
					this.$router.push({ path: '/login', query: { redirect: current } });
				} catch (e) { /* ignore */ }
			}
		}
	}
</script>

<style>
	.date-selector input[type="date"]:focus {
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
	}
	
	.date-selector input[type="date"]:hover {
		border-color: #999;
	}
</style>

<style scoped>
.uplimit-progress-page {
	--col-width: 140px;
}
@media (max-width: 768px) {
	.uplimit-progress-page {
		--col-width: 150px;
	}
}

/* 页面级样式，模态样式已封装到 PlateKlineModal 组件内 */
.ranking-item {
	border: 1px solid var(--border-color, lightgray);
	color: var(--text-main, #333);
	border-radius: 4px;
	padding: 2px 4px;
	background-color: var(--bg-card, #fff);
	min-height: 28px; /* 匹配 PlateTextItem 高度 */
	line-height: 22px;
	font-size: 0.85rem;
}
.ranking-highlight-1 {
	background-color: #dc3545 !important;
	color: #fff !important;
	border-color: #dc3545 !important;
}
.ranking-highlight-2 {
	background-color: #ffc107 !important;
	color: #212529 !important;
	border-color: #ffc107 !important;
}

/* 板块爆发原因样式 */
.plate-reasons {
	margin-top: 16px;
	border-top: 1px solid var(--border-color);
	padding-top: 12px;
	max-height: 300px;
	overflow-y: auto;
}
.plate-reasons-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--text-main);
	margin-bottom: 10px;
}
.plate-reasons-header h5 {
	margin: 0;
	font-size: 14px;
}
.plate-reasons .loading { font-size: 12px; color: var(--text-muted); }
.plate-reasons .empty { font-size: 13px; color: var(--text-muted); }
.plate-reasons .login-btn { margin-left: 8px; padding: 2px 10px; border-radius: 16px; font-size: 12px; }
.reasons-list { display: flex; flex-direction: column; gap: 10px; }
.reason-item { padding: 8px; border: 1px solid var(--border-color); border-radius: 6px; background-color: var(--bg-card); }
.reason-title { display: flex; gap: 8px; align-items: center; font-weight: 600; flex-wrap: wrap; }
.reason-title .date { font-size: 12px; color: var(--text-muted); }
.reason-title .boom { font-size: 12px; color: #d23; border: 1px solid #d23; border-radius: 3px; padding: 0 4px; }
.reason-title .title { font-size: 14px; color: var(--accent-color); text-decoration: none; cursor: pointer; }
.reason-meta { display: flex; gap: 12px; font-size: 12px; color: var(--text-muted); margin-top: 4px; }
.reason-text { font-size: 13px; margin-top: 6px; line-height: 1.4; color: #d23; }
.reason-lz { font-size: 12px; margin-top: 4px; color: var(--text-main); }
.reason-content { margin-top: 8px; font-size: 13px; line-height: 1.6; color: var(--text-main); }
.reason-detail-meta { font-size: 12px; color: var(--text-muted); margin-bottom: 6px; }

/* Mode switch item styles */
.mode-switch-item {
	font-size: 12px;
	font-weight: bold;
	color: #ced4da;
	cursor: pointer;
	padding: 4px 2px;
	border-radius: 4px;
	transition: all 0.2s;
	width: 36px;
	text-align: center;
	border: 1px solid transparent;
}
.mode-switch-item:hover {
	color: var(--primary, #007bff);
	background-color: rgba(0, 123, 255, 0.05);
}
.mode-switch-item.active {
	color: #fff;
	background-color: var(--primary, #007bff);
	border-color: var(--primary, #007bff);
}

/* 锁定遮罩及模糊效果样式 */
.locked-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(12px) saturate(180%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

body.theme-dark .locked-overlay {
  background: rgba(15, 23, 42, 0.35);
}

.lock-circle {
  width: 56px;
  height: 56px;
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border: 1px solid rgba(255, 193, 7, 0.3);
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.1);
  animation: lock-float 3s ease-in-out infinite;
}

.blur-content {
  filter: blur(12px);
  pointer-events: none;
  opacity: 0.45;
  transition: all 0.4s ease;
}

@keyframes lock-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.sub-plates-filter-bar {
  border-bottom: 1px solid var(--border-color, #e9ecef);
  padding-bottom: 6px;
  margin-bottom: 4px;
}
.filter-label {
  font-size: 12px;
  font-weight: bold;
  color: var(--text-muted, #6c757d);
}
.filter-pill-tag {
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 12px;
  cursor: pointer;
  background-color: var(--bg-muted, #f8f9fa);
  color: var(--text-main, #333);
  border: 1px solid var(--border-color, #e9ecef);
  transition: all 0.2s ease;
  user-select: none;
}
.filter-pill-tag:hover {
  color: var(--primary, #007bff);
  background-color: rgba(0, 123, 255, 0.08);
  border-color: var(--primary, #007bff);
}
.filter-pill-tag.active {
  color: #ffffff;
  background-color: var(--primary, #007bff);
  border-color: var(--primary, #007bff);
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.25);
}

body.theme-dark .filter-pill-tag {
  background-color: #1e293b;
  color: #cbd5e1;
  border-color: #334155;
}
body.theme-dark .filter-pill-tag:hover {
  color: #60a5fa;
  background-color: rgba(96, 165, 250, 0.1);
  border-color: #60a5fa;
}
body.theme-dark .filter-pill-tag.active {
  color: #ffffff;
  background-color: #3b82f6;
  border-color: #3b82f6;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.4);
}
</style>
